import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { isEmpty } from 'lodash';
import { nullFunc } from '../../utils/helpers';
import Subtitle from '../../components/Subtitle';
import Barber from '../Barber';
import { barberShape } from '../../shapes';
import { ANY_BARBER } from '../../constants';
import analytics from '../../applicationServices/analytics/BookingAnalytics';

const Barbers = ({
  barbers,
  generateUrlString,
  allowBookWithAnyBarber,
  onBarberClick,
  shop,
}) => (
  <div>
    <Subtitle>
      Pick a professional
    </Subtitle>
    <div className="u-mb">
      {allowBookWithAnyBarber && (
        <Link
          to={generateUrlString({ barberRoute: ANY_BARBER })}
          className="c-btn c-btn--secondary u-width-430 u-inline-block"
          onClick={() => { analytics.selectBarber(ANY_BARBER, { shop }); }}
        >
          Book With Any Professional
        </Link>
      )}
    </div>
    <div className="layout">
      {isEmpty(barbers) && (
        <div className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up">
          There are no professionals for selected shop
        </div>
      )}
      {!isEmpty(barbers) &&
        barbers.map(barber => (
          <div
            key={barber.id}
            className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up"
          >
            <Barber
              link={generateUrlString({ barberRoute: barber.route })}
              barber={barber}
              onClick={onBarberClick}
              disabled={barber.disabled}
            />
          </div>
        ))}
    </div>
  </div>
);
Barbers.propTypes = {
  barbers: PropTypes.arrayOf(barberShape).isRequired,
  generateUrlString: PropTypes.func.isRequired,
  allowBookWithAnyBarber: PropTypes.bool.isRequired,
  onBarberClick: PropTypes.func,
  shop: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};
Barbers.defaultProps = {
  onBarberClick: nullFunc,
};

export default Barbers;



// WEBPACK FOOTER //
// ./src/app/barbers/components/Barbers.jsx